export class ContextMenu {
  type: string;
  params: {} = {};
  menus: ContextMenu[] = [];
}
